<input
  #titleInput
  [class]="inputStyle"
  [value]="formControl.value"
  (input)="onInput($event)"
  [style.width]="(formControl.value?.length || 1) + 1 + 'ch'"
  (input)="titleInput.style.width = (titleInput.value.length || 1) + 1 + 'ch'"
  (blur)="onBlur()"
  (keydown.enter)="onEnter()"
  (keydown.escape)="onEscape()"
/>
